import { GeoTabDevice, GeotabDeviceStatusInfoRes } from '../models/GeotabRes';
import { HttpExecuteQueryReq } from '../proxy/proxy';
import { AxiosHttpIntegrationsClient } from '../proxy/ProxyClients';
import EnumService from './EnumService';

const HttpQueriesService = {
  geotabDeviceStatusInfo: async () => {
    const bodyJsonObject: any = {
      method: 'Get',
      params: {
        typeName: 'DeviceStatusInfo'
      },
      id: '2',
      jsonrpc: '2.0'
    };

    const payload: HttpExecuteQueryReq = {
      actionId: 101,
      queryParams: null,
      additionalQueryStringParams: null,
      headers: null,
      bodyJsonObject
    };

    const externalApiProviderTypes = await EnumService.getEnums('externalApiProviderTypes');
    const geoTabProviderId = externalApiProviderTypes.find((x) => x.value === 'GeoTab')?.id ?? 0;

    return AxiosHttpIntegrationsClient.execute(geoTabProviderId, payload).then((resp) => resp.result);
  },

  geotabDevice: async (deviceIds: string[]) => {
    const bodyJsonObject: any = {
      method: 'Get',
      params: {
        typeName: 'Device',
        search: { deviceIds },
        propertySelector: {
          fields: [
            'id', 'name', 'groups', 'autoGroups', 'activeTo', 'productId',
            'deviceFlags', 'devicePlanBillingInfo', 'serialNumber', 'comment',
            'isActiveTrackingEnabled', 'forceActiveTracking', 'deviceType'
          ]
        }
      }
    };

    const payload = {
      actionId: 101,
      queryParams: null,
      addtionalQueryStringParams: null,
      headers: null,
      bodyJsonObject
    };

    const externalApiProviderTypes = await EnumService.getEnums('externalApiProviderTypes');
    const geoTabProviderId = externalApiProviderTypes.find((x) => x.value === 'GeoTab')?.id ?? 0;

    return AxiosHttpIntegrationsClient.execute(geoTabProviderId, payload).then((resp) => resp.result);
  }
};

export default HttpQueriesService;
